import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBWkeDff05Xzz-IB6hxVXxDSfyY_cTGSaY",
  authDomain: "office-world-project-9730c.firebaseapp.com",
  projectId: "office-world-project-9730c",
  storageBucket: "office-world-project-9730c.firebasestorage.app",
  messagingSenderId: "925446804619",
  appId: "1:925446804619:web:7747c81e9ae215c90cb08e",
  measurementId: "G-1K2QMRXXP6",
};

let messaging: ReturnType<typeof getMessaging>;

if (typeof window !== "undefined" && "navigator" in window) {
  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
}

export { messaging };
